import moment from 'moment-timezone';
import React, { useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Container from "react-bootstrap/Container";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useRouter } from "util/router";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {NavLink} from 'util/router'
// import track from 'react-tracking';
// import branch from 'branch-sdk';
import analytics from 'util/analytics';
import "./ClassList.scss";
import Section from "./Section";
import {wakeupCheckout} from 'util/api/CheckoutAPI'
import {useAuth} from 'util/auth'
import {getBookmarks} from 'store/actions/widgetActions'
import Image from 'react-bootstrap/Image';
import { Route, Switch } from "util/router.js";
import BackButton from 'components/BackButton'
import Spinner from 'react-bootstrap/Spinner'
import {useChallenge} from 'util/challengeWidgetProvider'
import { useForm, Controller } from "react-hook-form"
import { DevTool } from "react-hook-form-devtools";
import Form from 'react-bootstrap/Form'
import CustomReactSelect from 'components/Store/CustomReactSelect';
// import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
// import 'pure-react-carousel/dist/react-carousel.es.css';
import _ from 'lodash'
import Slider from "react-slick";
import Collapse from 'react-bootstrap/Collapse'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './onDemandList.scss'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function OnDemandCard({name, description, dateString, clickHandler, imageUrl, className, style}) {
    return (
        <div className={className} onClick={clickHandler} style={style}>
        <Card border='transparent' className={'onDemandCard p-0 m-1 mb-3'}>
        <Card.Body className='p-0'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className="w-100">
                        <div
                        style={{height: "0px",
                            overflow: "hidden",
                            paddingTop: "56.25%",
                            background: "white",
                            position: "relative"}}
                            >
                            <div style={{
                                position: "absolute",
                                
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%"}}>
                                    <Image 
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", overflow: "hidden"}}
                                    src={imageUrl ?? "https://via.placeholder.com/1600x900.jpg"} />
                            </div>
                            
                        </div>
                        <div className="p-2">
                            <Card.Title className='mb-1' style={{
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                fontSize: "17px"
                            }}>
                                {name}
                            </Card.Title>
                            <Card.Text className="m-0 p-0">
                                {dateString}
                            </Card.Text>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </Card.Body>
        </Card>
        </div>
    )
}

function OnDemandCard2({name, description, dateString, clickHandler, imageUrl, className, style, type, duration}) {
    return (
        <div className={className} onClick={clickHandler} style={style}>
        <Card border='transparent' className={'onDemandCard2 p-0 m-1 mb-3'}>
        <Card.Body className='p-0'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className="w-100">
                        <div
                        style={{height: "0px",
                            overflow: "hidden",
                            paddingTop: "56.25%",
                            background: "transparent",
                            position: "relative"}}
                            >
                            
                            <div style={{
                                position: "absolute",
                                borderRadius: "5px",
                                overflow: "hidden",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%"}}>
                                    <Image 
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", overflow: "hidden"}}
                                    src={imageUrl ?? "https://via.placeholder.com/1600x900.jpg"} />
                            </div>
                            <div 
                            className="hoverable"
                            style={{
                                position: "absolute",
                                borderRadius: "5px",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%"}}>
                                <div className="w-100 h-100 d-flex justify-content-center"
                                // style={{position: "relative"}}
                                >
                                    <PlayArrowIcon 
                                    style={{
                                        // position: "absolute",
                                            // bottom: "30%",
                                            // right: "40%",
                                            color: "white",
                                            width: "40px",
                                            height: "40px"}}
                                    className={"m-auto" + (type === "product" ? " d-none" : "")} />
                                </div>
                            </div>
                            {/* <div 
                            // className="hoverable"
                            className={duration ? "" : "d-none"}
                            style={{
                                position: "absolute",
                                borderRadius: "5px",
                                bottom: "4px",
                                right: "4px",
                                paddingRight: "4px",
                                paddingLeft: "4px",
                                // width: "100%",
                                // height: "100%",
                                backgroundColor: 'black',
                                color: 'white'}}>
                                    <p className="mb-0" style={{color: 'white'}}>{duration}&nbsp;min</p>
                            </div> */}
                            
                        </div>
                        <div className="p-2">
                            <Card.Title className='mb-1' style={{
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                fontSize: "17px"
                            }}>
                                {name}
                            </Card.Title>
                            <Card.Text className={"m-0 p-0" + (type === "product" ? " d-none" : "")}>
                                {dateString}
                            </Card.Text>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </Card.Body>
        </Card>
        </div>
    )
}

function SampleNextArrow(props) {
    const { className, style, onClick, color } = props;
    return (
        <div
            // className={className}
            // className="arrow arrow-next"
            className={className + " browse-right-arrow"}
            style={{ ...style}}
            onClick={onClick}
        >
            <div
            className="h-100"
            style={{position: "relative"}}
            >
                <ArrowForwardIosIcon
                style={{color: color,
                    position: "absolute",
                    // marginTop: "auto",
                    // marginBottom: "auto",
                    // float: "right",
                    left: "75%",
                    top: "30%"}}
                ></ArrowForwardIosIcon>
            </div>
            
            {/* <i></i> */}
        </div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick, color } = props;
    return (
      <div
        // className={className}
        className={className + " browse-left-arrow"}
        style={{ ...style}}
        onClick={onClick}
      >
          <div
          className="h-100"
            style={{position: "relative"}}
            >
                <ArrowBackIosIcon
                style={{color: color,
                position: "absolute",
                // float: "left",
                right: "40%",
                top: "30%"}}
                ></ArrowBackIosIcon>
            </div>
      </div>
    );
  }
  

function SimpleSlider({items, openVideo}) {

    const textColor = useSelector(state => (state.widget.instructor.instructorProfile?.textColor ?? '#343a40'));
    // const {items} = props
    // render() {
     
      
    // }
    var settings = {
        arrows: true,
        // dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4.1,
        slidesToScroll: 4,
        initialSlide: 0,
        lazyLoad: true,
        nextArrow: <SampleNextArrow color={textColor} />,
        prevArrow: <SamplePrevArrow color={textColor} />,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4.1,
                slidesToScroll: 4,
                initialSlide: 0,
                // infinite: true,
                // dots: true
              }
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3.1,
                slidesToScroll: 3,
                initialSlide: 0,
                // initialSlide: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                initialSlide: 0,
              }
            }
          ]
    };
    return (
        <Slider {...settings}>
            {items.map(val => {
                var dateString = moment(val.created * 1000).format("dddd MMM Do")
                return (
                    <OnDemandCard2
                    key={val.platformID}
                    className="pr-2"
                    // style={{height:}}
                    duration={val.duration}
                    name={val.name || val.class_name}
                    description={val.description}
                    dateString={dateString}
                    clickHandler={() => openVideo(val)}
                    imageUrl={val.images && val.images.length > 0 ? val.images[0] : null}
                    />
                )
            })}
        </Slider>
    );
  }

moment.locale('en', {
    calendar : {
        lastDay : '[Yesterday]',
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek : '[last] dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'MMM Do [at] LT'
    }
});


function OnDemandListFilters(props) {

    const isLoading = useSelector(state => state.widget.isLoading)
    const instructorId = useSelector(state => state.widget.instructor.platformID)

    const defaultValues = {
        category: "",
        workout_type: "",
        body_focus: "",
        equipment: "",
        duration: "",
        filter: ""
    }
    const {classes} = props
    const { register, handleSubmit, errors, control, setValue, getValues, watch, reset } = useForm({
        mode: 'onBlur',
        defaultValues: defaultValues
    });
    
    const {category,
    workout_type,
    body_focus,
    equipment,
    duration, 
    filter} = watch()
    const onChange = (change) => {
        if (props.onUpdateFilters) {
            props.onUpdateFilters({
                category,
                workout_type,
                body_focus,
                equipment,
                duration,
                filter,
                ...change
            })
        }
    }

    const onSubmit = data => console.log(data);
    console.log(errors);

    /// CATEGORIES
    const mappedCategories = [{
        label: instructorId === "YeJgk1NtG6aW4CFLWSaBThjEsfg1" ? "Teachers" : "Categories",
        value: ""
    }].concat(classes.map(val => {
        if (val.categories && val.categories.length > 0) {
            return val.categories.map(cat => {
                return {
                    label: cat,
                    value: cat
                }
            })
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var categoryOptions = _.map(
        _.uniq(
            _.map(mappedCategories, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );

    // CUSTOM FILTERS
    const mappedFilters = [{
        label: "Filters",
        value: ""
    }].concat(classes.map(val => {
        if (val.filters && val.filters.length > 0) {
            return val.filters.map(filter => {
                return {
                    label: filter,
                    value: filter
                }
            })
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var filterOptions = _.map(
        _.uniq(
            _.map(mappedFilters, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );

    // END CUSTOM FILTERS

    const mappedWorkoutTypes = [{
        label: "Workout Types",
        value: ""
    }].concat(classes.map(val => {
        if (val.workout_types && val.workout_types.length > 0) {
            return val.workout_types.map(type => {
                return {
                    label: type,
                    value: type
                }
            })
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var workoutOptions = _.map(
        _.uniq(
            _.map(mappedWorkoutTypes, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );

    const mappedBodyFocus = [{
        label: "Body Focus",
        value: ""
    }].concat(classes.map(val => {
        if (val.body_focus) {
            return {
                label: val.body_focus,
                value: val.body_focus
            } 
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var bodyFocusOptions = _.map(
        _.uniq(
            _.map(mappedBodyFocus, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );

    const mappedEquipment = [{
        label: "Equipment",
        value: ""
    }].concat(classes.map(val => {
        if (val.equipment_required && val.equipment_required.length > 0) {
            return val.equipment_required.map(type => {
                return {
                    label: type,
                    value: type
                }
            })
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var equipmentOptions = _.map(
        _.uniq(
            _.map(mappedEquipment, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    )

    const mappedDuration = [{
        label: "Length",
        value: ""
    }].concat(classes.map(val => {
        if (val.duration) {
            return {
                label: val.duration,
                value: val.duration
            } 
        }
        return null
    })).filter(x => !!x).flat().sort((a,b) => {
        if (a.value < b.value) {
            return -1
        } else if (a.value > b.value) {
            return 1
        }
        return 0
    })
    var durationOptions = _.map(
        _.uniq(
            _.map(mappedDuration, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );
    
    const [filtersOpen, setFiltersOpen] = React.useState(false)
    
    return (<>

    <div className={"d-flex d-row mb-4 " + (isLoading ? "invisible" : "")}>
        <button
            className="btn btn-outline-primary primaryColor"
            type="button"
            onClick={(e) => {
                e.preventDefault()
                setFiltersOpen(!filtersOpen)
            }}
            aria-controls="collapse-filters"
            aria-expanded={filtersOpen}
        >
            <i className="fa fa-sliders-h" />&nbsp;
            <span>Filters</span>
        </button>

        {(category || workout_type || body_focus || equipment || duration ) && (        
            <a
                className="btn btn-link primaryColor"
                onClick={(e) => {
                    e.preventDefault()
                    
                    reset(defaultValues)
                    onChange(defaultValues)
                }}
            >
                Reset
            </a>
        )}


    </div>
            
    <Collapse in={filtersOpen}>

        <div id="collapse-filters" className="row">
            
            <Form.Group className={"col-md-2 " + (categoryOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect1">
                <Controller
                    as={CustomReactSelect}
                    options={categoryOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Category"}
                    name={"category"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            category: x
                        })

                    }}
                />
            </Form.Group>
            <Form.Group className={"col-md-2 " + (workoutOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect2">
                <Controller
                    as={CustomReactSelect}
                    options={workoutOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Workout Type"}
                    name={"workout_type"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            workout_type: x
                        })
                    }}
                />
            </Form.Group>
            <Form.Group className={"col-md-2 " + (bodyFocusOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect2">
                <Controller
                    as={CustomReactSelect}
                    options={bodyFocusOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Body Focus"}
                    name={"body_focus"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            body_focus: x
                        })
                        if (props.onSelectInstructor) {
                            props.onSelectInstructor(x)
                        }
                        console.log("new instructor type: ", x)
                    }}
                />
            </Form.Group>
            <Form.Group className={"col-md-2 " + (equipmentOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect2">
                <Controller
                    as={CustomReactSelect}
                    options={equipmentOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Equipment"}
                    name={"equipment"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            equipment: x
                        })
                    }}
                />
            </Form.Group>
            <Form.Group className={"col-md-2 " + (durationOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect2">
                <Controller
                    as={CustomReactSelect}
                    options={durationOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Duration"}
                    name={"duration"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            duration: x
                        })
                    }}
                />
            </Form.Group>
            <Form.Group className={"col-md-2 " + (filterOptions.length > 2 ? "" : "d-none")} controlId="exampleForm.ControlSelect1">
                <Controller
                    as={CustomReactSelect}
                    options={filterOptions}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    placeholder={"Filters"}
                    name={"filter"}
                    isMulti={false}
                    newSelection={ (x) => {
                        onChange({
                            filter: x
                        })
                    }}
                />
            </Form.Group>
            

        </div>
    </Collapse>

    <DevTool control={control} />
    </>);
}

function OnDemandListSection(props) {

    const categoryFilter = useQuery().get('category');
    const bookmarksMap = useSelector(state => state.widget.bookmarksMap)
    const reservationsMap = useSelector(state => state.user.reservations.reduce((map, obj)=> {
        if (obj.serverReservationObjectId) {
            map[obj.serverReservationObjectId] = obj
        }
        return map
    },{}))

    const {products, ondemand, challengeid} = props
    const { match } = props;

    const challengeWidget = useChallenge()
    const selectedChallenge = challengeWidget?.challenge

    const [filters, setFilters] = React.useState({})
    let initialClasses = useSelector(state => state.widget.onDemands.filter(val => {
        var categories = val.categories
        if (bookmarksMap[val.id] && !categories.includes('Favorites')) {
            val.categories = categories.concat('Favorites')
        }
        if (reservationsMap[val.id] && !categories.includes('Previously Watched')) {
            val.reservation = reservationsMap[val.id]
            val.categories = categories.concat('Previously Watched')
        }
        if (ondemand) {
            return val.location_type === 'ondemand'
        } else if (products) {
            return val.location_type === 'product'
        }
        return true
    }).filter(val => {
        if (challengeid) {
            if (val.challengeId === challengeid) {
                return true
            }
            if (selectedChallenge && selectedChallenge.listPublicLocationTypes && selectedChallenge.locationTypes.includes(val.location_type)) {
                if (val.challengeId && val.challengeId !== challengeid) {
                    return false
                }
                return true
            }
            return false
        } else {
            return !val.challengeId
        }
    }))

    let instructorId = (initialClasses && initialClasses.length > 0) ? initialClasses[0].instructor_id : null

    let allClasses = initialClasses.filter(val => {
        // else {
        //     includesCategory = true
        // }

        var includesWorkoutType = true
        if (filters.workout_type) {
            includesWorkoutType = val?.workout_types?.includes(filters.workout_type)
        }

        var includesBodyFocus = true
        if (filters.body_focus) {
            includesBodyFocus = val?.body_focus === filters.body_focus
        }

        var includesEquipment = true
        if (filters.equipment) {
            includesEquipment = val?.equipment_required?.includes(filters.equipment)
        }

        var includesDuration = true
        if (filters.duration) {
            includesDuration = val?.duration === filters.duration
        }

        var includesFilters = true
        if (filters.filter) {
            includesFilters = val?.filters?.includes(filters.filter)
        }

        return includesWorkoutType && includesBodyFocus && includesEquipment && includesDuration && includesFilters
    })
    const instructor = useSelector(state => state.widget.instructor);
    const isLoading = useSelector(state => state.widget.isLoading)
    // const userData = useSelector(state => state.user.userData)
    // const dispatch = useDispatch()
    // useEffect(() => {
    //     if (instructor) {
    //         dispatch(fetchOndemand(instructor.id))
    //     }
    // }, [userData, instructor, dispatch])
    
    
    // var workoutTypes = ""
    // if (instructor && instructor.instructorProfile && instructor.instructorProfile.workoutTypes && instructor.instructorProfile.workoutTypes.length > 0) {
    //     // console.log(user.instructorProfile.workoutTypes)
    //     // workoutTypes = user.instructorProfile.workoutTypes.joined(', ')
    //     // workoutTypes = 'Upcoming Digital Classes'
    // }

    useEffect(() => {
        wakeupCheckout().then(res => console.log(res))
    }, [])

    const auth = useAuth()
    const dispatch = useDispatch()
    useEffect(() => {

        if (auth.userData && instructor?.platformID) {
            console.log("FETCHING BOOKMARKS")
            dispatch(getBookmarks(instructor.platformID))
        }
    }, [instructor?.platformID, auth.userData])

    useEffect(() => {
        if (instructor) {
            analytics.page({
                title: 'On Demand List'
            })
            analytics.track("Viewed On Demand List", instructor)
        }
    }, [instructor])

    const router = useRouter()
    // console.log("Router: ", router)
    function stripTrailingSlash(str) {
        if(str.substr(-1) === '/') {
            return str.substr(0, str.length - 1);
        }
        return str;
    }

    function openVideo(val) {
        // console.log(window.branch)
        analytics.track("On Demand List Clicked View Details")

        router.push(`${stripTrailingSlash(router.match.url)}/checkout/${val.platformID}`)
    }

    // const [filteredClasses, setFilteredClasses] = React.useState(allClasses)
    // function updateFilters({}) {

    // }

    

    

    // const classesByCategory = allClasses.reduce((map, obj) => {
    // const classesByCategory = filteredClasses.reduce((map, obj) => {
    const classesByCategory = allClasses.reduce((map, obj) => {
        if (!obj.categories) {
            return map
        }
        if (obj.categories.length === 0) {
            if (map[""]) {
                map[""].push(obj)
            } else {
                map[""] = [obj]
            }
            return map
        }

        obj.categories.forEach(category => {
            if (categoryFilter && categoryFilter !== category.toLowerCase().replace(/\s/g, '')) {
                return
            }
            if (map[category]) {
                map[category].push({...obj})
            } else {
                map[category] = [{...obj}]
            }
        })
        return map
    }, {})

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (
        <div
        className="pt-0 mt-0"
        >
            <OnDemandListFilters
                classes={initialClasses}
                onUpdateFilters={(newFilters) => setFilters(newFilters)}
            />
            <Switch>
                <Route 
                    path={`${match.url}/:category`} 
                    render={props => {
                        const { match } = props;
                        const categoryURI = match.params.category
                        const category = decodeURIComponent(categoryURI).replace('${}','#').replace( '${-}', "/")
                        return (
                        <>
                        <BackButton/>
                        <h3
                        className={instructorId === "6eVF9IAIopfm57Jo1Gf9shRO71O2" ? "specialK" : ""}
                        >{category}</h3>
                        <div className="row">
                        {

                            (classesByCategory[category] ?? []).sort((a,b) => {
                                if (a.created && b.created) {
                                    if(a.created < b.created) { return 1; }
                                    if(a.created > b.created) { return -1; }
                                }
                                if(a.name < b.name) { return -1; }
                                if(a.name > b.name) { return 1; }
                                return 0;
                            }).map(val => {
                                var dateString = moment(val.created * 1000).format("dddd MMM Do")
                                return (
                                    <OnDemandCard2
                                    key={val.platformID}
                                    className="col-lg-4 col-md-6"
                                    // style={{}}
                                    name={val.name || val.class_name}
                                    description={val.description}
                                    dateString={dateString}
                                    clickHandler={() => openVideo(val)}
                                    imageUrl={val.images && val.images.length > 0 ? val.images[0] : null}
                                    />
                                )
                            })
                        }
                    </div>
                        
                        </>
                        )
                    }} 
                />
                <Route path="/"
                render={props => {
                    const sortingArray = {
                        "eoWmGPJME9MmnBWl3awMW07vl5X2": [ // Naomi Australia
                            "move",
                            "core",
                            "arms",
                            "legs",
                            "stretch"
                        ],
                        "6eVF9IAIopfm57Jo1Gf9shRO71O2": [
                            "fullbody",
                            "upperbody",
                            "core",
                            "lowerbody",
                            "cardio"
                        ],
                        "WGLXMuafTBRMQ2e6U4khuVmKy672": [ // Savannah
                            "weeklypicks",
                            "thisweek'spicks!",
                            "sweat",
                            "quicksweat",
                            "sculpt",
                            "sweatysculpt",
                            "sweat+sculpt",
                            "under20mins",
                            "stretch",
                        ],
                        "UzQ4BQ8VDPWHhA1kw2AEiTN5M4B3": [
                            "pilatesmat",
                            "barre"
                        ],
                        "YeJgk1NtG6aW4CFLWSaBThjEsfg1": [ // Chorus
                            "mk",
                            "maddy",
                            "luigi",
                            "kevin",
                            "ellie",
                            "dana",
                        ],
                        "6Xu3D3U78ECawtfKds2h": [
                            "bodyweighthiittothebeat",
                            "strength45(fullbody)",
                            "mobility30",
                            "strength30(upperbody)",
                            "strength30(fullbody)",
                            "strength30(core)",
                            "sculpt45(fullbody)",
                            "core",
                            "upperbody",
                            "lowerbody"
                        ],
                        "LMESHTvbbjRaWU2Hc3YJ": [
                            "sculpt",
                            "flow",
                            "restore",
                            "slowflow"
                        ],
                        "eoWmGPJME9MmnBWl3awMW07vl5X2": [
                            'move',
                            'core',
                            'upper',
                            'lower',
                            'stretch'
                        ],
                        "PEy9G4uUWme1mzkd3IcLUzMtg203": [ // Money maker workouts
                            "newworkouts",
                            "let'sbreakitdown",
                            "totalbodysculpt",
                            "burnbabyburn",
                            "express(under45mins)",
                            "abs+ass",
                            "absfordays",
                            "tonedarms",
                            "bootywork",
                            "stretch",
                            "holidayhustlechallenge",
                            "freeworkouts"
                        ],
                        "atE0Wc0aRuTcUY0gPssYx0LFCwt2": [ // beth wholebeeing
                            'newlyadded!',
                            "fluidpowerflows|60-minutepractices",
                            "restoreflows|60-minutepractices",
                            "shorterpractices",
                            "guidedmeditations&breathwork",
                            "guestteacherflows|60-minutepractices",
                            "workshops"
                        ],
                        "F5JwAtwqmYZl3wivGI90YdtKo0O2": [
                            "liveworkouts"
                        ],
                        "MFpcwQTXLET9cab0EVBOGmRiVez2" : [ // luminous
                            "newest",
                            "theflow",
                            "themovement",
                            "thebreath",
                            "thestillness"
                        ],
                        "VtWhSQ8gKHexYZ0X41gULzgncvz1" : [
                            "new!",
                            "vinyasa",
                            "hiit",
                            "buti",
                            "corecrunch",
                            "vin-yin",
                            "gentleyoga",
                            "mediation"
                        ],
                        "JCrMkMpQSHRszfOmEWi233WMas62": [
                            "freetoview",
                            "workouts",
                            "trainerworkouts",
                            "meditations"
                        ],
                        "zedCbUOuTEV1HjQbXb6p31vMmdv1": [
                            "what'snew"
                        ],
                        "2uV9wC1HiYQl9Ai1uXAzi6sbiKb2": [
                            "thenewestdryp"
                        ],
                        "2c22KiWPw4OTRQgTorvyiiVpWyk1": [
                            "barre",
                            "stretchbarre",
                            "stretch",
                            "cardio",
                            "abs+arms",
                            "core",
                            "glutework",
                            "yoga"
                        ],
                        "2O1APzYms3ayvV4AKzCbq65jKpy2": [
                            "snapseries",
                            "full50minuteclass",
                            "30-40minuteburn",
                            "recovery",
                        ],
                        "BefpaEo2A7cSjpprB9bhQft6Dir2": [
                            "quickies",
                            "metasculpt",
                            "metacardio",
                            "metapower",
                            "mastermeta",
                            "collabs",
                            "recentlyadded"
                        ],
                        "bZOsytLoGcbmyHxpHsJ4AUxe7hZ2": [
                            "newlyadded"
                        ]
                    }
                    const categoryKeysFirst = Object.keys(classesByCategory).sort((a,b) => {
                        const regex = /^\Day ([1-9]|1[0-9])\b/gm

                        const Amatch = a.match(regex)
                        const Bmatch = b.match(regex)

                        if (Amatch && Bmatch) {
                            const numberA = Number(Amatch[0].split(" ")[1])
                            const numberB = Number(Bmatch[0].split(" ")[1])
                            console.log("got matches")
                            console.log(numberA)
                            console.log(numberB)
                            return numberA - numberB
                        }

                        if (instructorId && sortingArray[instructorId]) {
                            const sortingArrayICareAbout = sortingArray[instructorId]
                            const aIndex = sortingArrayICareAbout.indexOf(a.toLowerCase().split(" ").join(""))
                            const bIndex = sortingArrayICareAbout.indexOf(b.toLowerCase().split(" ").join(""))
                            if (aIndex >= 0 && bIndex >= 0) {
                                return aIndex - bIndex
                            } else if (aIndex >= 0) {
                                return -1
                            }
                            return 0
                            // return sortingArrayICareAbout.indexOf(a.toLowerCase().split(" ").join("")) - sortingArrayICareAbout.indexOf(b.toLowerCase().split(" ").join(""))
                        }

                        if(a < b) { return -1; }
                        if(a > b) { return 1; }
                        return 0;

                    }).filter(val => {
                        if (filters.category) {
                            return val === filters.category
                        }
                        return true
                    })

                    const categoryKeys = [
                        ...categoryKeysFirst.filter(x => !!(x === 'Favorites')),
                        ...categoryKeysFirst.filter(x => !(x === 'Favorites'))
                    ]
                    return (
                    <>
                    {categoryKeys.length > 1 ? (<>
                        {categoryKeys.map((category) => {
                            
                            const classesForThisCategory = classesByCategory[category].sort((a,b) => {
                                if (challengeid === 'lKPNHBJUUMjxg6do5xjy') {
                                    if(a.name < b.name) { return -1; }
                                    if(a.name > b.name) { return 1; }
                                }
                                if (a.created && b.created) {
                                    if(a.created < b.created) { return 1; }
                                    if(a.created > b.created) { return -1; }
                                }

                                if(a.name < b.name) { return -1; }
                                if(a.name > b.name) { return 1; }
                                return 0;
                            })
                            return (
                            <div key={category} className="w-100 pb-3">
                                
                                    <div className="d-flex d-row align-items-baseline">
                                        <h3
                                        className={instructorId === "6eVF9IAIopfm57Jo1Gf9shRO71O2" ? "specialK" : ""}
                                        >{category}&nbsp;&nbsp;</h3>
                                        {classesForThisCategory.length > 1 && (
                                            <NavLink
                                            className="primaryColor noDecoration"
                                            to={`${match.url}/${encodeURIComponent(category).replace('#','${}').replace("/", '$ : ""{-}')}`}
                                            >
                                                <span className="small">View All</span>
                                             </NavLink>
                                        )}
                                    </div>
                                
                                
                                <SimpleSlider
                                openVideo={openVideo}
                                items={classesForThisCategory}
                                
                                />

                            </div>)
                        })}
                    </>) : (<>
                        {categoryKeys.map((category) => {
                            const classesForThisCategory = classesByCategory[category].sort((a,b) => {
                                if (challengeid === 'lKPNHBJUUMjxg6do5xjy') {
                                    if(a.name < b.name) { return -1; }
                                    if(a.name > b.name) { return 1; }
                                }
                                if (a.created && b.created) {
                                    if(a.created < b.created) { return 1; }
                                    if(a.created > b.created) { return -1; }
                                }

                                if(a.name < b.name) { return -1; }
                                if(a.name > b.name) { return 1; }
                                return 0;
                            })
                            return (
                            <div key={category} className="w-100 pb-3">
                                <h4>{category}</h4>
                                <div className="row">
                                    {
                                        classesForThisCategory.map(val => {
                                            var dateString = moment(val.created * 1000).format("dddd MMM Do")
                                            return (
                                                <OnDemandCard2
                                                key={val.platformID}
                                                className="col-lg-4 col-md-6"
                                                type={val.location_type}
                                                // style={{}}
                                                name={val.name || val.class_name}
                                                description={val.description}
                                                dateString={dateString}
                                                clickHandler={() => openVideo(val)}
                                                imageUrl={val.images && val.images.length > 0 ? val.images[0] : null}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </div>)
                        })}

                    </>)}
                    </>
                    )
                }} 
                />
                    
            </Switch>

            {isLoading && (
            <div className="text-center p-5">
                <Spinner
                    animation="border"
                    size="md"
                    aria-hidden={true}
                    className="ml-2"
                >
                    <span className="sr-only">Loading</span>
                </Spinner>
            </div>
            )}
        
        
        </div>
    );
}

export default OnDemandListSection;
